import React, {useState} from 'react'

import Header from '../../Header/Header';
import dayjs from 'dayjs';


import { useDispatch, useSelector } from 'react-redux';

import './CalculatorScreen.css'
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, Drawer, InputBase, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Toolbar } from '@mui/material';
import { aggregateData, filterDataByDate, filterDataByFields, filterDataByUser } from '../../../dataFunctions/functions';
import CalculatorLegend from '../../CalculatorLegendPopup/CalculatorLegend';
import { Cell, Label, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';


function CalculatorScreen() {
  
  const [legendOpen, setLegendOpen] = useState(false)

  const dispatch = useDispatch()
  const normalData = useSelector((state) => state.normalData.value)
  const userData = useSelector((state) => state.user.value)
  
  // current year
  let today = new Date();
  const startDate = dayjs(new Date(today.getFullYear(), 0, 1))
  const endDate = dayjs(new Date(today.getFullYear(), 11, 31).setHours(24, 0, 0, -1))

  const ratioOfYearSoFar = 1 - (endDate - today)/(1000 * 60 * 60 * 24)/365

  const data = aggregateData(
    filterDataByFields(
      filterDataByUser(
        filterDataByDate(normalData, 
        startDate, endDate), 
      [userData]), 
      ['opens', 'contacts', 'intros']
  ))

  // const contactsPerOpen = 254/54
  const contactsPerOpen = data.contacts/data.opens
  const introsPerOpen = data.intros/data.opens

  const investmentAvgCaseSize = userData.incomeGoals.averageCaseSize
  const investmentConversionRate = 0.25

  const incomeGoal = userData.incomeGoals.insuranceGoal
  // const opensGoal = 

  const goalCloses = incomeGoal/investmentAvgCaseSize
  const goalOpens = goalCloses/investmentConversionRate
  const goalContacts = goalOpens * contactsPerOpen
  const goalIntros = goalOpens * introsPerOpen

  const rows = [
    {
      label: 'Opens',
      value: Math.floor(goalOpens),
      backgroundColor: 'white'
    },
    {
      label: 'Contacts',
      value: Math.floor(goalContacts),
      backgroundColor: 'white'
    },
    {
      label: 'Introductions',
      value: Math.floor(goalIntros),
      backgroundColor: 'white'
    }
  ]

  const realIncome = data.opens*investmentConversionRate*investmentAvgCaseSize

  const calculateColor = (pace, goal) =>
  {
    if (Math.floor(pace) >= Math.floor(goal))
    {
      return "#d9ead3"
    }
    else
    {
      return "#f4cccc"
    }
    // else if (Math.floor(pace) < Math.floor(goal))
    // {
    //   return "#f4cccc"
    // }
    // else
    // {
    //   return "white"
    // }

  }

  const rows2 = [
    {
      label: 'Opens',
      value: data.opens ? data.opens : 0,
      backgroundColor: "white"
    },
    {
      label: 'Contacts',
      value: data.contacts ? data.contacts : 0,
      backgroundColor: "white"    
    },
    {
      label: 'Introductions',
      value: data.intros ? data.intros : 0,
      backgroundColor: "white"
    },
  ]

  const paceOpens = data.opens/ratioOfYearSoFar
  const paceContacts = data.contacts/ratioOfYearSoFar
  const paceIntros = data.intros/ratioOfYearSoFar
  const paceCloses = paceOpens*investmentConversionRate
  const paceIncome = paceCloses*investmentAvgCaseSize

  const rows3 = [
    {
      label: 'Opens',
      value: Math.floor(paceOpens),
      backgroundColor: calculateColor(paceOpens, goalOpens)
    },
    {
      label: 'Contacts',
      value: Math.floor(paceContacts),
      backgroundColor: calculateColor(paceContacts, goalContacts)
    },
    {
      label: 'Introductions',
      value: Math.floor(paceIntros),
      backgroundColor: calculateColor(paceIntros, goalIntros)
    },
  ]

  const calculatorColumn = (header, tooltip, incomeGoal, rows) =>
  {
      const tableHeaderCellStyle = {
        color : "white", 
        fontWeight: 'bold', 
        fontSize: "1.2vw", 
        fontFamily: "var(--primary-font-family)"
    }

    const tableBodyCellStyle = {
        color : "var(--primary-color)", 
        fontWeight: 'bold', 
        fontSize: "1.2vw", 
        fontFamily: "var(--primary-font-family)"
    }

    return <div className= "calculator-screen-column">
      <div className='calculator-screen-column-header'>
        {header}
      </div>
      <TableContainer component={Paper} sx = {styles.columnTable}>
        <Table sx={{ fontFamily: "var(--primary-font-family)"}}>
          <TableHead>
          {/* <Tooltip title = {<div className='calculator-screen-tooltip'>{tooltip}</div>} placement="right"> */}

            <TableRow sx = {{backgroundColor: "var(--primary-color)"}}>
              <TableCell sx = {tableHeaderCellStyle}>{"Income"}</TableCell>
                <TableCell sx = {tableHeaderCellStyle} align="right">${incomeGoal.toLocaleString('en', {useGrouping:true})}</TableCell>
            </TableRow>
            {/* </Tooltip> */}

          </TableHead>

          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.label}
                sx = {{backgroundColor: row.backgroundColor}}
                // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row" sx = {tableBodyCellStyle}>
                  {row.label}
                </TableCell>
                <TableCell align="right" sx = {tableBodyCellStyle}>{row.value.toLocaleString('en', {useGrouping:true})}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  }

  const datapie = [
    { name: 'A', value: realIncome, color: 'var(--primary-color)' },
    { name: 'B', value: paceIncome - realIncome, color: 'var(--secondary-color)' },
    { name: 'C', value: incomeGoal - paceIncome , color: 'gray' },
  ];

const iR = window.innerHeight * 0.15;
const oR = window.innerHeight * 0.20;

  return (
    <div style={{ display: 'flex', height: "100%", width: "100%" }}>

    <main className='calculator-screen'>
      <div className='calculator-screen-header'>
        Premium Projection
      </div>
      {/* <div className='calculator-screen-pie'>

        <ResponsiveContainer width={'100%'} height={'100%'}>

          <PieChart >
            <Pie
              dataKey="value"
              startAngle={180}
              endAngle={0}
              data={datapie}
              cx="50%"
              cy="100%"
              innerRadius={iR}
              outerRadius={oR}
              fill="#8884d8"
            >
              {datapie.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
                <Label position = "center" fill = {'var(--primary-color)'} fontSize={'2vw'}>
                  { '$' + realIncome.toLocaleString('en', {useGrouping:true})} 
                </Label>
                
            </Pie>
            <Tooltip/>

          </PieChart>
        </ResponsiveContainer>
      </div> */}

      <div className = "calculator-screen-columns">
        {calculatorColumn("Premium Projected YTD", "Income = Opens x Conversion Rate x Case Size", Math.floor(realIncome), rows2)}
        {calculatorColumn("Calendar Year Premium Projection", "Income = Opens x Conversion Rate x Case Size", Math.floor(paceIncome), rows3)}
        {calculatorColumn("Premium Goal", "Income = Opens x Conversion Rate x Case Size", incomeGoal, rows)}
      </div>
      
      



      
      {/* realIncome = data.opens*investmentConversionRate*investmentAvgCaseSize */}
      {/* <div className='calculator-screen-legend'>
      </div> */}
      <div className='calculator-screen-help-icon' onClick={() => setLegendOpen(!legendOpen)} style={{ position: "absolute", color: 'white', textAlign: 'center', fontSize: 25, fontWeight: 600, height: 38, width: 38, right: 20, bottom: 20, backgroundColor: '#14213D', borderRadius: '50%', boxShadow: "0px 5px 13px 0px rgba(0,0,0,0.5)" }}>?</div>
      {legendOpen && <CalculatorLegend 
                        ratioOfYear = {1 - ratioOfYearSoFar} 
                        averageCaseSize = {userData.incomeGoals.averageCaseSize}
                        contactsPerOpen = {contactsPerOpen}
                        introsPerOpen = {introsPerOpen}
                        conversionRate = {investmentConversionRate}
                        />}
    </main>




    


    
    
    </div>
  )
}

const styles = {
  columnTable : {
    width: '26vw',
    boxShadow: "0px 8px 15px 5px rgba(0,0,0,0.10)"
  },
  
  
}


export default CalculatorScreen